module.exports = __webpack_public_path__ + "img/flag.9ee3abb1.svg";